import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';

import PDPAddToBagSection from 'components/consumer/PDP/PDPAddToBagSection';
import Placeholder from 'components/consumer/Placeholder';
import RatingAndReviews from 'components/consumer/RatingAndReviews';
import PDPGalleryLabelsAndViewingCount from 'components/consumer/PDP/PDPGalleryLabelsAndViewingCount';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import ModularPDPRatingAndReviews from './ModularPDPRatingAndReviews';
import PDPPriceAndFinance from './PDPPriceAndFinance';
import usePdpSlug from '../state/context/usePdpSlug';

const CUSTOMER_PHOTOS_ID = '#PDPCustomerPhotos';

const PDPNameSectionUI = ({
  isEditOrder = false,
  loading,
  name,
  numberOfReviews,
  pdpIsModularBYOProduct = false,
  rating,
  reviewsLoading = false,
  subtitle,
}) => {
  const history = useHistory();
  const location = useLocation();
  const pdpSlug = usePdpSlug();

  const onRatingsAndReviewClick = event => {
    event.preventDefault();
    history.push('customer-reviews');
  };

  const nameFromRouterState = location?.state?.name;
  const isNameLoading = loading && !nameFromRouterState;
  const nameToDisplay = loading ? nameFromRouterState : name;

  return (
    <>
      <div className="flex flex-row items-center">
        <h1 className="text-xl font-bold text-gray md:text-2xl md:font-bold pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0 mb-1.5 md:mt-10">
          {isNameLoading ? (
            <Placeholder
              type="rect"
              loading
              className="!w-full lg:!w-[310px]"
              style={{
                height: '23px',
              }}
            />
          ) : (
            nameToDisplay
          )}
        </h1>

        <MobileAndTabletOnly>
          <div className="flex flex-row items-center lg:hidden">
            <PDPGalleryLabelsAndViewingCount />
          </div>
        </MobileAndTabletOnly>
      </div>

      {subtitle && (
        <div className="pb-1.5 pl-5 md:pl-8 lg:pl-0.5">
          <span className="text-sm">{subtitle}</span>
        </div>
      )}

      <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0">
        {pdpIsModularBYOProduct ? (
          <ModularPDPRatingAndReviews
            onClick={onRatingsAndReviewClick}
            href={CUSTOMER_PHOTOS_ID}
          />
        ) : (
          <RatingAndReviews
            loading={reviewsLoading}
            rating={rating}
            numberOfReviews={numberOfReviews}
            onClick={onRatingsAndReviewClick}
            href={CUSTOMER_PHOTOS_ID}
          />
        )}
      </div>

      <div className="bg-white pt-4 px-0 pb-3 sticky top-0 z-[999] lg:z-[1001] lg:items-center lg:flex lg:justify-between lg:px-0 lg:py-5 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:pl-0 lg:pr-0">
        <PDPPriceAndFinance
          isEditOrder={isEditOrder}
          key={pdpSlug} // Re-mount component when slug changes
          loading={loading}
          pdpIsModularBYOProduct={pdpIsModularBYOProduct}
        />

        {!isEditOrder && (
          <DesktopOnly>
            <div className="ml-2 max-[1023px]:hidden">
              <PDPAddToBagSection
                stickyDesktopButtonOnly
                pageLoading={loading}
              />
            </div>
          </DesktopOnly>
        )}
      </div>
    </>
  );
};

PDPNameSectionUI.propTypes = {
  isEditOrder: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  numberOfReviews: PropTypes.number,
  pdpIsModularBYOProduct: PropTypes.bool,
  rating: PropTypes.number,
  reviewsLoading: PropTypes.bool,
  subtitle: PropTypes.string,
};

export default PDPNameSectionUI;
